import units from "@evercam/shared/plugins/units"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(units(null))
